module.exports = __webpack_public_path__ + "img/new-logo.f50bdf5d.png";